import setup from '~/setup/minimal'

import { installer } from '~/analytics/main/installer'

setup().then(() => {
  installer()
})
